import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Axios from 'axios';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import 'react-toggle/style.css';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import isEqual from 'lodash/isEqual';
import head from 'lodash/head';
import getPath from 'lodash/get';
import Dots from 'react-activity/lib/Dots';
import {
  createEditorState,
  editorStateToRaw,
  editorStateToRawAndHtml,
  rawIsEmpty,
} from '../../../../helpers/editorStateHelper.js';

import styles from '../shared/styles';
import {
  authManager,
  soundcastManager,
  soundcastExtManager,
} from '../../../../helpers/managers';
import { ALERTS, encodeQuotes } from '../../../../helpers/texts';
import { getExactAudioWorkerRootHost } from '../../../../helpers/misc';
import userTour from '../../../../helpers/tour';
import { hasCustomPaymentUrl } from '../../../../helpers/soundcasts';
import { getSoundcastsEpisodes } from '../../../../managers/soundcast';
import ImageCropModal from '../../../../components/ImageCropModal';
import {
  getUserProStatus,
  getSoundcastsManagedv2,
  isSoundcastsManagedLoadedAndCompleted,
  canUserAccessFeature,
  canUserUse100PercenOffCoupon,
  hasUserExceededPodcastFeedLimit,
} from '../../../../helpers/userinfoHelper';
import { ActionButton } from '../../../../components/buttons/buttons';
import Loading from '../../../../components/Loading';
import { RowDivision, LoadingWrapper } from '../../../../styles/styled';
const {
  podcastCategories,
  canPublisherAccessFeature,
  isFreeAccount,
  trimSpaces,
  getRandomColor,
  shortDescriptionPgCompatible,
} = require('../../../../../server/scripts/utils.js')();
import Status from './status';
import Title from '../shared/Title';
import Description from './description';
import Category from './category';
import CoverArt from './coverart';
import Features from './features';
import Hosts from './hosts';
import IntroOutro from './introoutro';
import Dripping from './dripping';
import Pricing from './pricing';
import OtherSettings from './othersettings';
import Subscription from './subscription';
import {
  findMinimumPriceIfPriceIsLessThanAllowed,
  hasDiscountsBelowMinimumPrice,
  hasValidCouponCodes,
} from '../../../../helpers/payments';
import { signupConfirmBodyTemplate } from '../../../../../server/scripts/helpers/emailTemplate';

const categories = Object.keys(podcastCategories).map(i => podcastCategories[i].name);
import { soundcast2state } from '../soundcast_fields.js';

class EditSoundcast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      notFound: false,
      soundcastId: '',
      userPlan: '',
      showIntroOutro: false,
      introOutroUpdated: false,
      disableReProcessSoundcast: true,
      disableReProcessByPlan: true,
      enableToggleTrackListOnLandingPage: canPublisherAccessFeature(
        this.props.userInfo.publisher,
        'SOUNDCAST_TRACKLIST_LANDING_TOGGLE'
      ),
      imageCropModalOpen: false,
      doneProcessingPodcast: false,
      startProcessingPodcast: false,
      hasPublicEpisodes: false,
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Upgrade',
        onClose: () => {},
        upgrade: false,
        dismissible: true,
      },
      imagecrop: {
        show: false,
        onCrop: () => {},
        onClose: () => {},
        file: null,
      },

      ...soundcast2state(),
    };

    this.saveSoundcast = this.saveSoundcast.bind(this);
    this.onAddSecondHostInstructor = this.onAddSecondHostInstructor.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onResetToDefaultConfirmationEmail = this.onResetToDefaultConfirmationEmail.bind(this);
    this.onSoundcastInputChange = this.onSoundcastInputChange.bind(this);
    this.onSoundcastStateChange = this.onSoundcastStateChange.bind(this);
    this.showIntroOutro = this.showIntroOutro.bind(this);
    this.modalHandler = this.modalHandler.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleChargeOption = this.handleChargeOption.bind(this);
    this.handleCreatePodcast = this.handleCreatePodcast.bind(this);
    this.openImageCropModal = this.openImageCropModal.bind(this);
    this.closeImageCropModal = this.closeImageCropModal.bind(this);
    this.initFilepondImageCropperFor = this.initFilepondImageCropperFor.bind(this);
  }

  async componentDidMount() {
    await this.assignSoundcast();

    const disableReProcessByPlan = !canUserAccessFeature('SOUNDCAST_INTRO_OUTRO_REPLACE');
    this.setState({
      disableReProcessByPlan,
    });
  }

  async componentDidUpdate() {
    await this.assignSoundcast();
  }

  static getDerivedStateFromProps(nextProps) {
    const { userInfo, managed } = nextProps;

    // soundcats managed should be ready
    if (!isSoundcastsManagedLoadedAndCompleted(managed)) {
      return null;
    }

    const userStatus = getUserProStatus(userInfo);
    return {
      ...userStatus,
    };
  }

  async assignSoundcast() {
    const { loaded = false, notFound = false} = this.state;
    if (loaded || notFound) {
      return;
    }

    const { managed, match } = this.props;
    const { id: soundcastId } = match.params;

    // soundcats managed should be ready
    if (!isSoundcastsManagedLoadedAndCompleted(managed)) {
      return;
    }

    // check soundcast public episodes
    this.checkPublicEpisodes();

    // assign soundcast details to state
    const soundcastManaged = getSoundcastsManagedv2();
    const soundcast = soundcastManaged.find(item => isEqual(item.id, soundcastId));
    if (isEmpty(soundcast)) {
      return this.setState({ notFound: true });
    }

    const { editorState: long_description } = createEditorState(soundcast.long_description);

    const confirmationEmailExt = await soundcastExtManager.getProp(soundcastId, 'confirmationEmail');
    const confirmationEmailJson = isEmpty(confirmationEmailExt)
      ? soundcast.confirmationEmail // deprecated
      : confirmationEmailExt;
    const {
      editorState: confirmationEmail,
      html: confirmationEmailHtml,
      isDefault: confirmationEmailIsDefault,
    } = createEditorState(confirmationEmailJson, signupConfirmBodyTemplate());

    const { userInfo: { email, publisher } } = this.props;
    const {
      title,
      itunesTitle,
      itunesOwner,
      itunesImage,
      itunesHost,
      hostName,
      imageURL,
    } = soundcast;

    this.setState({
      soundcastId,
      ...soundcast2state(soundcast),

      long_description,  // EditorState
      confirmationEmail, // EditorState
      confirmationEmailHtml,
      confirmationEmailIsDefault,

      itunesTitle: itunesTitle ? itunesTitle : title,
      itunesOwner: itunesOwner ? itunesOwner : head(email),
      itunesHost: itunesHost || hostName || publisher.name,
      itunesImage: itunesImage || (imageURL || '' )
        .replace('dummyimage.com/300.png/', 'dummyimage.com/1400.png/'),
      
      loaded: true,
      disableReProcessSoundcast: true,
    });
  }

  async checkPublicEpisodes() {
    try {
      const { match } = this.props;
      const { id: soundcastId } = match.params;

      // we check if the soundcast has at least 1 public episode
      const where = { publicEpisode: true };
      const { total = 0 } = await getSoundcastsEpisodes({
        soundcastId,
        page: 1,
        limit: 1,
        filter: { where },
      });
      if (total > 0) {
        this.setState({
          hasPublicEpisodes: true,
        });
      }
    } catch (err) {
      console.log(`Unable to load soundcast public episodes`, err.message);
      this.showModal({
        content: 'There was a problem loading soundcast additional details.',
      });
    }
  }

  onAddSecondHostInstructor(state = true) {
    return () => {
      const additional = !state
        ? {
            hostName2: '',
            hostBio2: '',
            hostImageURL2: '',
          }
        : {};

      this.setState({
        instructor2Input: state,
        ...additional,
      });
    };
  }

  onResetToDefaultConfirmationEmail() {
    const {
      editorState: confirmationEmail,
      html: confirmationEmailHtml,
      isDefault: confirmationEmailIsDefault,
    } = createEditorState('', signupConfirmBodyTemplate());
    this.setState({
      confirmationEmail,
      confirmationEmailHtml,
      confirmationEmailIsDefault,
    });
  }

  onSoundcastInputChange(key = 'title') {
    return e => {
      const input = e.target.value;
      this.setState({
        [key]: input || '',
      });
    };
  }

  onSoundcastStateChange(key = 'title', value = '', cb = () => {}) {
    return () => {
      const oldstatevalue = this.state[key];
      this.setState({ [key]: value }, () => {
        cb(oldstatevalue);
      });
    };
  }

  isShownSoundcastSignup() {
    const { userInfo } = this.props || {};
    const publisherPlan = getPath(userInfo, 'publisher.plan', 'free').toLowerCase();
    if (publisherPlan === 'basic') {
      return true;
    }
    if (!this.state.published) {
      return false;
    }
    if (!this.state.forSale) {
      return true;
    }

    return !isFreeAccount(userInfo) && ['plus', 'pro', 'platinum'].includes(publisherPlan);
  }

  areRequiredFieldsValid() {
    const { title, short_description, category } = this.state;
    return [title, short_description, category].every(value => !isEmpty(value));
  }

  // ??? not used
  deleteFileUpload(url) {
    return new Promise((resolve, reject) => {
      if (!url.includes('http')) {
        reject();
      }

      Axios.delete('/api/upload', {
        params: {
          url,
        },
      })
        .then(resolve)
        .catch(reject);
    });
  }

  // ??? not used
  async deleteAndUpdateOldFileTrace(key = '') {
    try {
      if (isEmpty(key)) {
        return false;
      }

      const { soundcastId } = this.state;
      const oldKeyData = await soundcastManager.getProp(soundcastId, `${key}`);
      if (!isEmpty(oldKeyData)) {
        await this.deleteFileUpload(oldKeyData);
        await soundcastManager.saveProp(soundcastId, `${key}`, this.state[key]);
      }
    } catch (e) {}
  }

  saveSoundcast(published, noAlert = false) {
    return () => {
      // before we proceed verify the required props first
      const canProceed = this.areRequiredFieldsValid();
      if (!canProceed) {
        return this.showModal({
          content: 'Please fill in all the required fields to continue.',
        });
      }

      this.setState({ saving: true }, () => {
        this.saveInternal(published, noAlert);
      });
    };
  }

  async saveInternal(published, noAlert = false, resolve = () => {}) {
    let {
      title,
      imageURL,
      blurredImageURL,
      previewImage,
      short_description,
      long_description,
      landingPage,
      features,
      featuresTitle,
      hostTitle,
      hostName,
      hostBio,
      hostImageURL,
      hostName2,
      hostBio2,
      category,
      hostImageURL2,
      forSale,
      prices,
      confirmationEmail,
      confirmationEmailHtml,
      confirmationEmailIsDefault,
      enableSignupEmail,
      showSubscriberCount,
      showListenCount,
      disableComment,
      showTrackListOnLandingPage,
      showTimeStamps,
      podcastFeedVersion,
      itunesTitle,
      itunesOwner,
      itunesHost,
      itunesLanguage,
      itunesImage,
      itunesExplicit,
      itunesCategory,
      autoSubmitPodcast,
      soundcastId,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
      applyHistoricallyIntroOutro,
      overlayDuration,
      introOutroUpdated,
    } = this.state;
    const { userInfo } = this.props;

    if (isEmpty(title)) {
      return this.showModal({
        title: 'Soundcast Title is missing',
        content: 'Please enter a soundcast title before saving.',
        onClose: () => this.setState({ saving: false }, resolve),
      });
    }

    if (isEmpty(short_description)) {
      return this.showModal({
        title: 'Soundcast Description is missing',
        content: 'Please enter a short description for the soundcast before saving.',
        onClose: () => this.setState({ saving: false }, resolve),
      });
    }

    if (isEmpty(category)) {
      return this.showModal({
        title: 'Soundcast Category is missing',
        content: 'Please choose a category before saving.',
        onClose: () => this.setState({ saving: false }, resolve),
      });
    }

    // if pricing isn't specified, then this is a free soundcast
    // else the price needs to be at least stripe minimum charge amount
    const hasPrice = !isEmpty(prices);
    if (!hasPrice) {
      prices = [{ billingCycle: 'free', price: 'free' }];
    } else if (forSale) {
      const foundMinimumPrice = findMinimumPriceIfPriceIsLessThanAllowed(prices);

      if (!isEmpty(foundMinimumPrice)) {
        return this.showModal({
          title: 'Soundcast price is invalid',
          content: [
            `The price needs to be at least ${foundMinimumPrice.currency} ${foundMinimumPrice.price}`,
            <br key={`${soundcastId}br`} />,
            `0 price allowed only for "one time rental" payment`,
          ],
          onClose: () => this.setState({ saving: false }, resolve),
        });
      }
    }

    if (!canUserUse100PercenOffCoupon(prices)) {
      return this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().SOUNDCAST_COUPONS_100POFF.NO_ACCESS,
        upgrade: true,
        onClose: () =>
          this.setState(
            {
              saving: false,
              startProcessingPodcast: false,
              doneProcessingPodcast: true,
            },
            resolve
          ),
      });
    }

    // prices of discounts should be not lower than minimum
    if (hasDiscountsBelowMinimumPrice(prices)) {
      return this.showModal({
        title: 'Coupon discount',
        content: 'One of your coupon codes discounted price is below the minimum charge amount.',
        onClose: () => this.setState({ saving: false }, resolve),
      });
    }

    // prices has coupon but invalid
    if (!hasValidCouponCodes(prices)) {
      return this.showModal({
        title: 'Coupon Code',
        content: 'You have entered an invalid coupon code.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // ensure some limitations are applied
    landingPage = canUserAccessFeature('SOUNDCAST_PRIVATE') ? landingPage : true;
    if (prices.length > 0 && !canUserAccessFeature('SOUNDCAST_MULTIPLE_PRICING')) {
      prices = [prices[0]];
    }

    // for platinum users with white label, generate productSku
    // under format priceIndex_billingCycle_soundcastId
    if (canUserAccessFeature('MOBILE_WHITE_LABEL')) {
      prices = prices.map((price, index) => {
        if (!('billingCycle' in price)) return price;
        return {
          ...price,
          productSku: `${index}_${trimSpaces(price.billingCycle)}_${soundcastId}`,
        };
      });
    }

    const user = authManager.getCurrentUser();
    if (user) {
      // ??? set imageURL if empty
      // TODO fix &text=.. for dummyimage
      imageURL = isEmpty(imageURL) || imageURL.includes('dummyimage.com')
        ? `https://dummyimage.com/300.png/${getRandomColor()}/ffffff&text=${encodeURIComponent(
            title
          )}`
        : imageURL;

      const creatorID = user.uid;
      const last_update = Number(moment().format('X'));
      const editedSoundcast = {
        title,
        short_description: shortDescriptionPgCompatible(short_description),
        confirmationEmail: null, // deprecated
        enableSignupEmail,
        // imageURL,
        // blurredImageURL,
        // previewImage,
        creatorID,
        publisherID: userInfo.publisherID,
        landingPage,
        features,
        featuresTitle,
        hostTitle,
        hostName,
        hostBio,
        hostImageURL,
        hostName2,
        hostBio2,
        hostImageURL2,
        forSale,
        prices,
        category,
        last_update,
        showTimeStamps,
        ...(showSubscriberCount ? { showSubscriberCount } : { showSubscriberCount: null}),
        showListenCount,
        disableComment,
        showTrackListOnLandingPage,
        published,
        itunesTitle,
        itunesOwner,
        itunesHost,
        itunesLanguage,
        // itunesImage,
        itunesExplicit,
        itunesCategory,
        autoSubmitPodcast,
        enableFaqOnLandingPage,
        enableRatings,
        disableSignup,
        applyHistoricallyIntroOutro,
        overlayDuration,
      };

      const { publisher = {} } = userInfo;
      const { id: publisherId, stripe_user_id = '' } = publisher;

      try {
        const longDescriptionRaw = editorStateToRaw(long_description);
        const {
          raw: confirmationEmailRaw,
          html: confirmationEmailHtmlNew,
        } = editorStateToRawAndHtml(confirmationEmail);
        const confirmationEmailRawJson =
          isEqual(confirmationEmailHtml, confirmationEmailHtmlNew) && confirmationEmailIsDefault 
          ? null
          : JSON.stringify(confirmationEmailRaw);

        // edit soundcast in database
        const existingSoundcast = await soundcastManager.getById(soundcastId);
        delete existingSoundcast.imageURL;
        delete existingSoundcast.blurredImageURL;
        delete existingSoundcast.previewImage;
        delete existingSoundcast.itunesImage;
        delete existingSoundcast.confirmationEmail;

        const changedSoundcast = {
          ...existingSoundcast,
          ...editedSoundcast,
          long_description: rawIsEmpty(longDescriptionRaw) ? null : JSON.stringify(longDescriptionRaw),
        };

        // // DBG
        // console.log(
        //   `***** edit_soundcast changedSoundcast`,
        //   JSON.stringify(changedSoundcast)
        // );

        await Promise.all([
          // save to firebase
          soundcastManager.update(soundcastId, changedSoundcast),
          soundcastExtManager.saveProp(soundcastId, 'confirmationEmail', confirmationEmailRawJson),

          // save to postgres
          Axios.post('/api/soundcast', {
            title,
            soundcastId,
            shortDescription: shortDescriptionPgCompatible(short_description),
            imageUrl: imageURL,
            previewImage,
            forSale,
            landingPage,
            published,
            updateDate: last_update,
            category,
            publisherId,
            applyHistoricallyIntroOutro,
            overlayDuration,
            hostName,
          }),
        ]);

        //if intro or outro was changed and historical change was requested - submitting it to audio worker
        if (introOutroUpdated && applyHistoricallyIntroOutro) {
          await Axios.post(`${getExactAudioWorkerRootHost()}/api/soundcast-reprocessing`, {
            soundcastId,
            options: {
              intro: !isEmpty(changedSoundcast.intro),
              outro: !isEmpty(changedSoundcast.outro),
              overlayDuration: editedSoundcast.overlayDuration,
            },
          });
          this.setState({ introOutroUpdated: false });
        }

        // if the publisher has stripe connected
        // and no custom payment url
        let stripeWarning = '';
        if (!isEmpty(stripe_user_id) && !hasCustomPaymentUrl(existingSoundcast)) {
          try {
            const result = await Axios.post('/api/check_stripe_account', {
              publisherId,
              stripe_user_id,
            });
            const { data = {}, status = 0 } = result || {};
            const { success = false, errorMessage = '' } = data;
            if (!success) {
              throw new Error(errorMessage || 'unknown error');
            }

            // only remove coupon for plan based plans and non trial coupons
            const couponsToRemove = [];
            (existingSoundcast.prices || [])
              .filter(({ billingCycle = '' }) => billingCycle !== 'one time')
              .forEach(price => {
                (price.coupons || [])
                  .filter(({ couponType = '' }) => couponType !== 'trial_period')
                  .forEach(coupon => couponsToRemove.push(coupon.code));
              });

            await Axios.post('/api/createUpdatePlans', {
              soundcastID: soundcastId,
              publisherID: publisherId,
              stripe_account: stripe_user_id,
              title,
              prices: landingPage && forSale ? prices : [],
              couponsToRemove, // old coupons removal
            });
          } catch (err) {
            stripeWarning = err.message || 'unknown error';
          }
        }

        // update feed for soundcast metadata
        if (!isNull(podcastFeedVersion)) {
          this.handleCreatePodcast(true);
        }

        // set user tour prop
        if (forSale && userTour.available()) {
          userTour.setUserProp('createdPricing', true);
        }

        if (!noAlert) {
          this.setState({ published }, () => {
            const okMessage = 'Your soundcast has been successfully updated.';
            const content = isEmpty(stripeWarning)
              ? okMessage
              : okMessage + ' With stripe warning: ' + stripeWarning;

            this.showModal({
              content,
              // onClose: history.goBack(),
            });
          });
        }
      } catch (err) {
        console.log('failed to complete update soundcast', err.message);
        this.showModal({
          title: 'Error Updating Soundcast',
          content: 'There was a problem updating your soundcast, please contact support.',
        });
      } finally {
        this.setState({ saving: false }, resolve);
      }
    }
  }

  handleChargeOption() {
    const { forSale } = this.state;
    const { userInfo } = this.props;
    if (!forSale) {
      if (!userInfo.publisher.stripe_user_id) {
        this.saveInternal(false, true);
        this.showModal({
          title: `Hold on, ${userInfo.firstName}! Please set up your payout first.`,
          content: `You need a payout account so that we could send you your sales proceeds. Please
                  save this soundcast, and go to publisher setting to enter your payout method,
                  before setting up soundcast pricing.`,
        });
      } else {
        this.setState({
          forSale: !forSale,
          prices: [{ paymentPlan: '', billingCycle: 'one time', price: 1, currency: 'USD' }],
        });
      }
    } else {
      this.setState({ forSale: !forSale, prices: [] });
    }
  }

  onEditorStateChange(statekey) {
    return editorState => {
      this.setState({ [statekey]: editorState });
    };
  }

  handlePaypalModalClose() {
    if (this.state.paypalModalOpen) {
      this.setState({ paypalModalOpen: false });
    }
  }

  showIntroOutro() {
    if (!canUserAccessFeature('SOUNDCAST_INTRO_OUTRO')) {
      return this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().SOUNDCAST_INTRO_OUTRO.NO_ACCESS,
        upgrade: true,
      });
    }

    this.setState(({ showIntroOutro }) => ({
      showIntroOutro: !showIntroOutro,
    }));
  }

  handleCreatePodcast(fastsave = false) {
    const { firstName, email } = this.props.userInfo;
    const {
      soundcastId,
      itunesImage,
      itunesExplicit,
      itunesCategory,
      podcastFeedVersion,
      autoSubmitPodcast,
      itunesTitle,
      itunesHost,
    } = this.state;

    // check if already reach the limit
    if (isNull(podcastFeedVersion) && hasUserExceededPodcastFeedLimit()) {
      return this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().ALLOWED_PODCAST_FEEDS.LIMIT_EXCEEDED,
        upgrade: true,
      });
    }

    const [itunesCategory1 = ''] = itunesCategory;
    if (isEmpty(itunesCategory) || isEmpty(itunesCategory1)) {
      return this.showModal({
        title: 'Category is missing',
        content: 'Please select at least one category to continue.',
      });
    }

    // workaround to detect real itunesImage
    const isRealImage = !isEmpty(itunesImage)
      ? itunesImage.includes('/soundwiseinc/soundcasts')
      : false;

    if (isEmpty(itunesImage) || !isRealImage) {
      return this.showModal({
        title: 'Cover art is not accepted',
        content:
          'Please upload a soundcast cover art to continue. The image needs to be between 1400x1400 and 3000x3000 pixels.',
      });
    }

    // save soundcast first before creating feed
    this.setState(
      {
        saving: true,
        startProcessingPodcast: true,
        doneProcessingPodcast: false,
      },
      async () => {
        try {
          await new Promise(resolve => {
            if (fastsave) return resolve();
            this.saveInternal(true, true, resolve);
          });

          try {
            await Axios.post('/api/create_feed', {
              soundcastId,
              itunesExplicit,
              itunesImage,
              itunesCategory,
              autoSubmitPodcast,
              firstName,
              email: email[0],
              soundcastTitle: itunesTitle,
              soundcastHost: itunesHost,
            });
          } catch (err) {
            console.error(`ERROR: /api/create_feed errored -`, err.message);
          }

          if (podcastFeedVersion) {
            if (fastsave) return;
            this.showModal({
              title: 'Podcast feed updated',
              content: 'Your podcast feed information has been edited!',
            });
          } else {
            this.props.increasePlanCurrentUsage({ type: 'podcast_feeds' });
            this.showModal({
              title: 'Podcast feed submitted',
              content:
                'Your podcast information is submitted. We will email you when the feed processing is done.',
            });
          }

          // update state for usage
        } catch (err) {
          const { response = {} } = err;
          const { status, data = '' } = response;
          let podcastError = !isEmpty(data) ? data : err.toString();
          if (status && status >= 500) {
            podcastError =
              'There was a problem processing podcast feed, please contact support at support@mysoundwise.com if the issue persists.';
          }

          console.log(err);
          this.showModal({
            content: podcastError,
          });
        } finally {
          this.setState({
            saving: false,
            startProcessingPodcast: false,
            doneProcessingPodcast: true,
          });
        }
      }
    );
  }

  renderImageCropModal() {
    const { show, onCrop, onClose, file } = this.state.imagecrop;
    return <ImageCropModal open={show} handleClose={onClose} onCrop={onCrop} file={file} />;
  }

  openImageCropModal(metadata) {
    this.setState({
      imagecrop: {
        show: true,
        onClose: this.closeImageCropModal,
        ...metadata,
      },
    });
  }

  closeImageCropModal() {
    this.openImageCropModal({
      show: false,
    });
  }

  initFilepondImageCropperFor(options) {
    this.openImageCropModal(
      options({
        close: this.closeImageCropModal,
      })
    );
  }

  renderHostInformation() {
    const {
      hostTitle,
      hostName,
      hostName2,
      hostBio,
      hostBio2,
      hostImageURL,
      hostImageURL2,
      instructor2Input,
      soundcastId,
    } = this.state;

    const list = [
      {
        hostName,
        hostBio,
        hostImageURL,
      },
    ];

    if (instructor2Input || !isEmpty(hostName2)) {
      list.push({
        hostName: hostName2,
        hostBio: hostBio2,
        hostImageURL: hostImageURL2,
      });
    }

    return (
      <Hosts
        soundcastId={soundcastId}
        hostTitle={hostTitle}
        list={list}
        onAdd={this.onAddSecondHostInstructor()}
        onRemove={this.onAddSecondHostInstructor(false)}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
        withCrop={true}
        cropperHandler={this.initFilepondImageCropperFor}
        autoDeletePrevious={true}
        autoSave={true}
      />
    );
  }

  renderIntroOutro() {
    const {
      showIntroOutro,
      intro,
      outro,
      soundcastId,
      overlayDuration,
      applyHistoricallyIntroOutro,
      disableReProcessSoundcast,
      disableReProcessByPlan,
    } = this.state;
    const { userInfo } = this.props;
    return (
      <IntroOutro
        publisherId={userInfo.publisherID}
        disableReProcessSoundcast={disableReProcessSoundcast}
        disableReProcessByPlan={disableReProcessByPlan}
        soundcastId={soundcastId}
        show={showIntroOutro}
        showHistoricalToggle={true}
        intro={intro}
        outro={outro}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
        handleShow={this.showIntroOutro}
        autoDeletePrevious={true}
        autoSave={true}
        overlayDuration={overlayDuration}
        applyHistoricallyIntroOutro={applyHistoricallyIntroOutro}
        onNoIntroOutroAlert={() => {
          this.showModal({
            title: 'Missing intro or outro requirements',
            content: 'Please upload intro/outro clip(s) to your soundcast to use this feature.',
          });
        }}
        onFeatureNotAllowed={() => {
          this.showModal({
            title: 'Upgrade Required',
            content: `Please upgrade your plan to access this feature.`,
            upgrade: true,
          });
        }}
      />
    );
  }

  renderContentDripping() {
    const { userInfo } = this.props;
    const { soundcastId, episodes = {} } = this.state;
    return (
      <Dripping
        soundcastId={soundcastId}
        publisherId={userInfo.publisherID}
        episodes={episodes}
        userInfo={userInfo}
        showModal={this.showModal}
      />
    );
  }

  renderPricingOptions() {
    const { landingPage, forSale, prices, userPlan, soundcastId } = this.state;
    return (
      <Pricing
        public={landingPage}
        forsale={forSale}
        prices={prices}
        userPlan={userPlan}
        soundcastId={soundcastId}
        onEnableCharge={this.handleChargeOption}
        onPricesUpdate={prices => this.onSoundcastStateChange('prices', prices)()}
        showModal={this.showModal}
      />
    );
  }

  renderOtherSettings() {
    const {
      soundcastId,
      itunesExplicit,
      itunesImage,
      itunesCategory = [],
      itunesTitle,
      itunesOwner,
      itunesHost,
      itunesLanguage,
      showTimeStamps,
      showSubscriberCount,
      showListenCount,
      disableComment,
      showTrackListOnLandingPage,
      enableToggleTrackListOnLandingPage,
      autoSubmitPodcast,
      podcastFeedVersion,
      startProcessingPodcast,
      doneProcessingPodcast,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
      hasPublicEpisodes,
    } = this.state;

    // for podcast, make sure there atleast 1 public episode
    // available in order to create the feed for this soundcast
    const allowed = hasPublicEpisodes;
    return (
      <OtherSettings
        soundcastId={soundcastId}
        showTimeStamps={showTimeStamps}
        showSubscriberCount={showSubscriberCount}
        showListenCount={showListenCount}
        disableComment={disableComment}
        showTrackListOnLandingPage={showTrackListOnLandingPage}
        enableToggleTrackListOnLandingPage={enableToggleTrackListOnLandingPage}
        enableFaqOnLandingPage={enableFaqOnLandingPage}
        enableRatings={enableRatings}
        disableSignup={disableSignup}
        podcast={{
          show: true,
          allowed,
          itunesExplicit,
          itunesImage,
          itunesCategory,
          itunesOwner,
          itunesTitle,
          itunesHost,
          itunesLanguage,
          podcastFeedVersion,
          autoSubmitPodcast,
          onUpdatePodcast: this.handleCreatePodcast,
          onPodcastNotAllowed: () => {
            this.showModal({
              content:
                'Please make sure your soundcast has at least 1 public track before generating a podcast feed.',
            });
          },
          cropperHandler: this.initFilepondImageCropperFor,
          startProcessingPodcast,
          doneProcessingPodcast,
        }}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
        onClickUpgrade={() => this.props.history.push('/pricing')}
        onFeatureNotAllowed={() => {
          this.showModal({
            title: 'Upgrade Required',
            content: `Please upgrade your plan to access this feature.`,
            upgrade: true,
          });
        }}
      />
    );
  }

  modalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      upgrade = false,
      onClose = false,
      dismissible = true,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            upgrade,
            dismissible,
            onClose: !show ? false : onClose,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  showModal(metadata = {}) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const { show, title, content, upgrade, dismissible = true, onClose } = this.state.modal;
    const actionLabel = upgrade ? 'Upgrade' : 'OK';
    const actionBtnClick = upgrade
      ? () => this.props.history.push('/pricing')
      : this.modalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton id="actionButtonTest1" onClick={actionBtnClick}>
          {actionLabel}
        </ActionButton>
        {upgrade && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={() => {
              this.modalHandler({ show: false })();
              if (onClose) {
                onClose();
              }
            }}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        }
        actions={actions}
        modal={!dismissible}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderSaveButtons() {
    const { saving } = this.state;

    let content = (
      <div className="col-lg-12" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 17, width: '100%', marginTop: 50 }}>
          <span>Saving</span>
        </div>
        <div className="" style={{ marginTop: 10, width: '100%' }}>
          <Dots color="#727981" size={32} speed={1} />
        </div>
      </div>
    );

    if (!saving) {
      content = (
        <React.Fragment>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              id="draft-btn"
              className="btn"
              style={styles.draftButton}
              onClick={this.saveSoundcast(false)}>
              <span>Save Draft</span>
            </div>
          </div>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              id="publish-btn"
              className="btn btn-default"
              style={{ ...styles.draftButton, ...styles.publishButton }}
              onClick={this.saveSoundcast(true)}>
              <span>Publish</span>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return <div style={styles.actionButtonWrapper}>{content}</div>;
  }

  render() {
    const {
      soundcastId,
      landingPage,
      published,
      title,
      short_description,
      long_description,
      imageURL,
      featuresTitle,
      features,
      category,
      confirmationEmail,
      enableSignupEmail,
      notFound = false,
    } = this.state;
    const { userInfo, match = {} } = this.props;
    const { id: paramsId = '' } = match.params || {};

    if (notFound) {
      return (
        <div style={{ padding: 20 }}>
          <div className="row" style={styles.rowDivision}>
            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
               <div style={styles.errorTxt} className="title-medium">
                 {`The given soundcast ${paramsId} does not exist`}
               </div>
            </div>
          </div>
        </div>
      );
    }

    if (isEmpty(soundcastId)) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="90">
            <Loading text="Loading soundcast, please wait" />
          </LoadingWrapper>
        </RowDivision>
      );
    }

    return (
      <MuiThemeProvider>
        <div>
          <div style={styles.topHeaderWrapper}>
            <div className="row">
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <div style={styles.topHeaderSwitcher}>
                  <div className="title-medium">Edit Soundcast</div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ minHeight: window.innerHeight - 83 - 70 }}>
            <div style={{ padding: '20px' }}>
              <Status
                soundcastId={soundcastId}
                public={landingPage}
                published={published}
                onStatusChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
                viewLinks={true}
              />
              <Title
                value={title}
                required={true}
                onChange={this.onSoundcastInputChange('title')}
              />
              <Description
                label="Short Description"
                required={true}
                value={short_description}
                placeholder="A short description of this soundcast (300 characters max)"
                helper="300 characters max"
                onChange={this.onSoundcastInputChange('short_description')}
              />
              <Category
                required={true}
                list={categories}
                value={category}
                onChange={category => this.onSoundcastStateChange('category', category)()}
              />
              <CoverArt
                publisherId={userInfo.publisherID}
                soundcastId={soundcastId}
                value={imageURL}
                datakey="imageURL"
                datakeyBlur="blurredImageURL"
                datakeyPreview="previewImage"
                withCrop={true}
                withBlur={true}
                withPreview={true}
                autoDeletePrevious={true}
                autoSave={true}
                cropperHandler={this.initFilepondImageCropperFor}
                onChange={(statekey, value) => {
                  // update original statekey
                  this.onSoundcastStateChange(statekey, value, () => {
                    // update itunesImage key to be the same
                    if (statekey === 'imageURL') {
                      const copyToProp = 'itunesImage';
                      this.onSoundcastStateChange(copyToProp, value, async () => {
                        await soundcastManager.saveProp(soundcastId, `${copyToProp}`, value);
                      })();
                    }
                  })();
                }}
              />
              <Features
                label="Features Section"
                helper="(list the main benefits and features of this soundcast)"
                placeholder="e.g. Learn how to analyze financial statement with ease"
                list={features}
                onChange={features => this.onSoundcastStateChange('features', features)()}
                onTitleChange={value => {
                  this.setState({
                    featuresTitle: value || '',
                  });
                }}
                title={featuresTitle}
                enableEnterAdd={true}
              />
              <Description
                label="Long Description"
                value={long_description}
                onChange={this.onEditorStateChange('long_description')}
                richEditor={true}
              />
              {this.renderHostInformation()}
              {this.renderIntroOutro()}
              {this.renderContentDripping()}
              {this.renderPricingOptions()}
              {this.renderOtherSettings()}
              <Subscription
                signupEmailValue={confirmationEmail}
                onChangeSignupEmail={this.onEditorStateChange('confirmationEmail')}
                onResetToDefaultEmail={this.onResetToDefaultConfirmationEmail}
                enableSignupEmail={enableSignupEmail}
                onChangeSignupEmailToggle={value =>
                  this.onSoundcastStateChange('enableSignupEmail', value)()
                }
              />
              {this.renderSaveButtons()}
            </div>
          </div>
          {this.renderAlertModal()}
          {this.renderImageCropModal()}
        </div>
      </MuiThemeProvider>
    );
  }
}

EditSoundcast.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
};

export default EditSoundcast;
